import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'activetime/machine';

const machineActiveService = {
  getMachineActive: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/machineActiveList`,
      data,
    });
  },

  createMachineActive: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/machineActive`,
      data,
    });
  },

  deleteMachineActive: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/machineActive/${encodeURIComponent(id)}`,
    });
  },

  updateMachineActive: (id, data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/machineActive/${encodeURIComponent(id)}`,
      data,
    });
  },

  createMachineActiveItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/machineActiveItem`,
      data,
    });
  },

  updateMachineActiveItem: (id, data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/machineActiveItem/${encodeURIComponent(id)}`,
      data,
    });
  },

  deleteMachineActiveItem: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/machineActiveItem/${encodeURIComponent(id)}`,
    });
  },

  getMachineActiveItemsById: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/machineActiveItem/${encodeURIComponent(id)}`,
    });
  },

  getMachineDayOff: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/machineDayOffList`,
      data,
    });
  },

  createMachineDayOff: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/machineDayOff`,
      data,
    });
  },

  deleteMachineDayOff: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/machineDayOff/${encodeURIComponent(id)}`,
    });
  },

  updateMachineDayOff: (id, data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/machineDayOff/${encodeURIComponent(id)}`,
      data,
    });
  },
};

export default machineActiveService;
